import React from 'react';
import PropTypes from 'prop-types';
import 'intersection-observer';
import { useInView } from 'react-intersection-observer';

const LazyLoadObserver = (props) => {

    const isComponent = props.isComponent ? props.isComponent : false; 

    const [ref, inView] = useInView({
        threshold: isComponent ? 0.1 : 0.3,
        triggerOnce: true
    });

    return <div ref={ref} className={(props.className || '') + (!inView && isComponent ? ' not-view ' : '')}>
        {inView && props.children}
    </div>

}

LazyLoadObserver.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    className: PropTypes.string,
    isComponent: PropTypes.bool
};

export default LazyLoadObserver;
